/**
 * @fileoverview ホームのレポート・記事混在テーマ用のカードレイアウトコンポーネント（「レポートのみ」、「記事のみ」の場合は別レイアウト）
 */
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import ContentsCard from '@/components/contents/ContentsCard.vue'

export default defineComponent({
  name: 'LayoutContentsCardsForHome',

  components: {
    ContentsCard,
  },

  props: {
    /**
     * コンテンツ情報の配列
     */
    items: {
      type: Array as PropType<ContentItem[]>,
      required: true,
    },
  },
})
</script>

<template>
  <div
    v-if="items.length"
    class="o-list__contentsCard">
    <ul class="o-list__contentsCard--items">
      <li
        v-for="(item, index) in items"
        :key="item.id"
        class="o-list__contentsCard--item">
        <template v-if="index === 0">
          <ContentsCard
            :item="item"
            :horizontal="{
              pc: false,
              sp: false,
            }"
            :heading-options="{ maxLine: 2 }"
            :image-options="{
              width: {
                pc: 308,
                sp: 137,
              },
              height: {
                pc: 170,
                sp: 72,
              },
            }" />
        </template>
        <template v-else>
          <ContentsCard
            :item="item"
            :horizontal="{
              pc: true,
              sp: true,
            }"
            :heading-options="{ maxLine: 2 }"
            :image-options="{
              width: {
                pc: 137,
                sp: 137,
              },
              height: {
                pc: 72,
                sp: 72,
              },
            }" />
        </template>
      </li>
    </ul>
  <!-- /.o-list__contentsCard --></div>
</template>

<style lang="sass" scoped>
.o-list__contentsCard
  $root: &
  $cols: 2
  $gap-px: 24
  $gap-percent: getRelativeValue($gap-px, $primary-col-width)
  $col-width: math.div(($primary-col-width - $gap-px * ($cols - 1)), $cols)
  $col-width-percent: getRelativeValue($col-width, $primary-col-width)
  margin: 1em auto 0

  &:first-child
    margin-top: 0

  // Phablet 以上のとき
  +breakpoint($max: false, $min: true)
    > #{$root}--items
      +clearfix

      #{$root}--item
        width: $col-width-percent
        float: right

        &:first-child
          float: left

        &:nth-child(n + #{($cols + 1)})
          margin-top: changeSizePx2Em($gap-px)

  // Phablet 未満のとき
  +breakpoint
    #{$root}--item
      margin-top: changeSizePx2Em(12)
      padding-top: changeSizePx2Em(12)
      border-top: 1px solid $border-x-light-gray

      &:first-child
        border-top: none
        padding-top: 0
        margin-top: 0
</style>
